import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectiveModule } from 'src/app/extensions/directives/directive.module';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { MyProfileComponent } from './my-profile.component';
import { ProfileRoutingModule } from './my-profile-routing.module';
import { ProfileCategorySelectorComponent } from './shared-components/profile-category-selector/profile-category-selector.component';
import { PartnerAddressListViewComponent } from './shared-components/partner-address-list-view/partner-address-list-view.component';
import { PartnerBankAccountListViewComponent } from './shared-components/partner-bank-account-list-view/partner-bank-account-list-view.component';
import { MyUserProfileComponent } from './my-user-profile/my-user-profile.component';
import { ProfileGeneralViewComponent } from './shared-components/profile-general-view/profile-general-view.component';

@NgModule({
  imports: [
    CommonModule,
    ProfileRoutingModule,
    FormsModule,
    PipeModule,
    NgbModule,
    TranslateModule.forChild(),
    DirectiveModule,
    ComponentsModule,
    ComponentsModule,
  ],
  declarations: [
    MyProfileComponent,
    MyUserProfileComponent,
    ProfileGeneralViewComponent,
    ProfileCategorySelectorComponent,
    PartnerAddressListViewComponent,
    PartnerBankAccountListViewComponent,
  ],
  exports: [],
})
export class ProfileModule {}
